export default __webpack_public_path__ + "static/get-it-all-bg-right-64c1a670b847d100067dfe771fcca2c8.png";